import * as React from 'react';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { isSinglePurchase, ProductDetailPrice } from '@grandvisionhq/fun-products';
import { useIntl } from '@grandvisionhq/state';
import { getAttrValue } from '@grandvisionhq/utils';
import { pushChangeSolutionVolumeEvent } from '../../../../DataLayer/change-solution-volume.js';
import '@grandvisionhq/analytics';
import '@swc/helpers';
import '@grandvisionhq/inventory';
import { getPrice } from '../../../../utils/get-price.js';
import { isVariantPublished } from '../../../../utils/is-variant-published.js';
import 'classnames';
import '@grandvisionhq/common';
import '@grandvisionhq/lib-visuals';
import { useProductDetailContext } from '../../../Context/ProductDetailContext.js';
import '@grandvisionhq/svc-monetate';
import '@grandvisionhq/reviews';
import { PackageQuantityDropdownContainer } from '../../../Components/PackageQuantityDropdown/PackageQuantityDropdownContainer.js';
import '@grandvisionhq/frk-routing';
import { useSolutionsEcommContext } from '../../context/SolutionsEcommContext.js';

const getPackageObject = (variant)=>{
    const price = getPrice(variant.prices);
    var ref, ref1;
    return {
        label: String(getAttrValue(variant, 'packageOption')),
        value: String(variant.sku),
        subtext: '',
        aside: /*#__PURE__*/ React.createElement(ProductDetailPrice, {
            originalPrice: (ref = price === null || price === void 0 ? void 0 : price.originalPrice) !== null && ref !== void 0 ? ref : 0,
            discountedPrice: (ref1 = price === null || price === void 0 ? void 0 : price.discountedPrice) !== null && ref1 !== void 0 ? ref1 : 0,
            currency: price === null || price === void 0 ? void 0 : price.currency,
            customSize: "small"
        })
    };
};
const PackageSelector = ({ variants , className  })=>{
    const { getLabel  } = useIntl();
    const { activeSku , activeVariant  } = useProductDetailContext();
    const { state , actions  } = useSolutionsEcommContext();
    const { purchaseType  } = state.configurations;
    React.useEffect(()=>{
        if (isSinglePurchase(purchaseType)) {
            return;
        }
        const isAvailableForSubscription = CommerceToolsApi.isSolutions(activeVariant) && !!activeVariant.isAvailableForSubscription;
        /**
     * if the user selects a new variant that either:
     * 1. is not available for subscription, or
     * 2. is available for subscription but does not have a subscription price,
     * then make sure the configurator is reset to 'single-purchase'
     */ if (!isAvailableForSubscription || activeVariant.purchaseTypePrices && !activeVariant.purchaseTypePrices[purchaseType]) {
            actions.updatePurchaseType('single-purchase');
        }
    }, [
        activeVariant,
        purchaseType
    ]);
    const packageItems = React.useMemo(()=>variants.filter(isVariantPublished).map(getPackageObject)
    , [
        variants
    ]);
    const handlePackSizeChange = React.useCallback((packageOption)=>{
        pushChangeSolutionVolumeEvent(packageOption.label);
    }, []);
    if (packageItems.length < 2) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(PackageQuantityDropdownContainer, {
        onChange: handlePackSizeChange,
        label: getLabel('products.solutions.selectVolume'),
        items: packageItems,
        selectedSize: activeSku,
        className: className
    });
};

export { PackageSelector };
//# sourceMappingURL=PackageSelector.js.map
